import Fuse from 'fuse.js';

import Context, {Type} from './SearchContext';
import {FilterType} from "@/components/DirectoryFilters";

export default class SearchEngine {

    /**
     * @param {array} datas
     * @param {Context} context
     */
    constructor(datas, context) {
        this.context = context;
        this.currentDatas = datas;
        this.searchOn = datas;
        this.initialState = datas;

        this.defaultOptions = {
            includeScore: true,
            includeMatches: true,
            minMatchCharLength: 3,
            threshold: 0.2,
            ignoreLocation: true,
            keys: [
                {name: 'display_name'},
                {name: 'nicename'},
                {name: 'first_name'},
                {name: 'last_name'},
                {name: 'email'},

                {name: 'journalist_group.function'},
                {name: 'journalist_group.city'},
                {name: 'journalist_group.medias.post_title'},
                {name: 'journalist_group.postal_code'},
                {name: 'journalist_group.pro_address'},
                {name: 'journalist_group.subjects'},
                {name: 'journalist_group.pro_phone'},
                {name: 'journalist_group.twitter'},

                {name: 'partner_group.orga_name'},
                {name: 'partner_group.orga_name_full'},
                {name: 'partner_group.orga_address'},
                {name: 'partner_group.orga_city'},
                {name: 'partner_group.orga_postal_code'}
            ]
        }

        this.Fuse = new Fuse(this.searchOn, this.defaultOptions);
    }

    /**
     * Search on string. If nothing is specified, search on the current searchOn context.
     * @param pattern
     * @param options
     * @returns {Fuse.FuseResult<unknown>[]|Array}
     */
    search(pattern = '', options = {}) {

        this.context.search = pattern;

        if (pattern === '') {
            this.filterSearchOnByType();
            this.filterSearchOn();
            return this.currentDatas = this.searchOn;
        }

        this.filterSearchOnByType();
        this.filterSearchOn();

        const searchResults = this.Fuse.search(pattern, options);

        console.log(searchResults);

        return this.currentDatas = searchResults.map((results) => results.item);
    }

    filterSearchOnByType() {
        const type = this.context.type;

        if (type === Type.Journalist) {
            this.searchOn = this.initialState.filter((item) => {
                return item.type && item.type.toLowerCase() === 'journaliste';
            });
        } else if (type === Type.Partner) {
            this.searchOn = this.initialState.filter((item) => {
                return item.type && item.type.toLowerCase() === 'partenaire';
            });
        }

        this.Fuse.setCollection(this.searchOn);
    }


    filterSearchOn() {
        if (!this.context.type || this.context.type !== 2) {

            if (this.context.filter === FilterType.ALL) {
                return;
            }

            this.searchOn = this.searchOn.filter((item) => {
                if ('journalist_group' in item && typeof item.journalist_group === 'object') {
                    return item.journalist_group.subjects.includes(this.context.filter);
                }

                return false;
            });

            this.Fuse.setCollection(this.searchOn);
        }
    }
}
